import * as z from "zod/v4";

const provideAiFeedbackInputSchema = z.object({
  scores: z.record(z.string(), z.number()),
  threadId: z.string(),
  comment: z.string().optional(),
});

const provideAiFeedbackOutputSchema = z.object({ success: z.boolean() });

export type ProvideAiFeedbackInput = z.infer<
  typeof provideAiFeedbackInputSchema
>;
export type ProvideAiFeedbackOutput = z.infer<
  typeof provideAiFeedbackOutputSchema
>;

export const provideAiFeedback = {
  name: "provideAiFeedback" as const,
  input: provideAiFeedbackInputSchema,
  output: provideAiFeedbackOutputSchema,
};
